import { Trash } from 'lucide-react'
import React, { useState } from 'react'

import { useParterManagedPayrollError } from 'components/hooks/payroll/usePartnerManagedPayrollError'
import { Button, useBreakpoint } from 'slab'
import { PayrollPayScheduleSource } from 'utils/web_api.schemas'

import { isPayScheduleActive } from './utils'
import { type PaySchedule } from '../../types/payroll'
import { useDeactivatePaySchedule } from '../hooks/useDeactivatePaySchedule'
import { ConfirmationDialog } from '../reusable/ConfirmationDialog'
interface DeactivatePayScheduleButtonProps {
  paySchedule: PaySchedule
  onSuccess?: () => void
  children?: React.ReactNode
  className?: string
}

export function DeactivatePayScheduleButton ({
  paySchedule,
  onSuccess,
  children,
}: DeactivatePayScheduleButtonProps) {
  const [openDialog, setOpenDialog] = useState(false)
  const { mutate: deactivatePaySchedule, isPending } = useDeactivatePaySchedule()
  const { showPartnerManagedError } = useParterManagedPayrollError()
  const isActive = isPayScheduleActive(paySchedule)

  const handleDeactivate = () => {
    deactivatePaySchedule(paySchedule.id, {
      onSuccess: () => {
        setOpenDialog(false)
        onSuccess?.()
      },
    })
  }

  const handleDeactivateButton = () => {
    if (paySchedule.source === PayrollPayScheduleSource.partner) {
      showPartnerManagedError('Cannot deactivate pay schedule')
    } else {
      setOpenDialog(true)
    }
  }

  const { breakpointIsAtLeast } = useBreakpoint()
  const buttonText = breakpointIsAtLeast('xs') ? 'Deactivate pay schedule' : 'Deactivate'

  return (
    <>
      <Button
        onClick={handleDeactivateButton}
        variant={isActive ? 'tertiary-destructive' : 'tertiary-deemphasized'}
        leftIcon={Trash}
        disabled={!isActive}
      >
        {children || buttonText}
      </Button>

      <ConfirmationDialog
        open={openDialog}
        onOpenChange={setOpenDialog}
        title='Are you sure you want to deactivate this pay schedule?'
        description='Thatch will not create future pay periods for this pay schedule'
        submitLabel='Deactivate'
        isDanger
        isSubmitting={isPending}
        onSubmit={handleDeactivate}
      />
    </>
  )
}
